import { MiniFooter } from '@smuchile/pkg-unimarc-components'
import {
  IEntriesProps,
  getMiniFooterContent,
  isValidArrayWithData
} from '@smuchile/pkg-unimarc-hooks'
import { IMiniFooter } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/IMiniFooter'
import Link from 'next/link'
import { useRouter } from 'next/router'

interface ClubUnimarcFooterProps {
  data: IEntriesProps
  margin?: string
}

export const ClubUnimarcFooter = ({
  data,
  margin = '0'
}: ClubUnimarcFooterProps) => {
  const router = useRouter()
  const footerData: IMiniFooter[] = getMiniFooterContent(
    data,
    router
  ) as IMiniFooter[]
  if (isValidArrayWithData(footerData))
    return (
      <MiniFooter
        data={footerData}
        linkWrapper={Link}
        margin={margin}
      />
    )
  return null
}
